import { useEngineStore } from "../store/engineStore";
import { Telemetry } from "./Telemetry";
import { NodeLabels } from "./NodeLabels";

export function Overlay() {
  const reset = useEngineStore((s) => s.reset);
  return (
    <div className="hud" aria-hidden={false}>
      <header className="topbar">
        <button className="brand" type="button" onClick={reset}>
          <span>AF</span>
          <div>
            <strong>AUDIO FUTURE</strong>
            <em>ENDLESS CULTURAL INTELLIGENCE</em>
          </div>
        </button>
      </header>
      <Telemetry />
      <NodeLabels />
    </div>
  );
}
